import GeoCodingService from "../../services/GeoCodingService"
import {
  addQuicklookPreviewAction,
  removeLastShapeAction,
  setSuggestionsAction,
  storeKMLGuideShapeAction,
  storeLastShapeAction,
} from "./actions"
import { ShapeType } from "../../types/shape"
import { validateShape } from "../../helpers/validateShapeHelper"
import { validateWithNotifications } from "../../helpers/validationHelper"
import { convertPathStringIntoShape } from "../../helpers/shapeHelper"
import { parseQuicklookPreviewFrom } from "../../helpers/parserHelper"
import ProductImageService from "../../services/ProductImageService"
import {ProductImageStacType, SearchResultsType} from "../../types/product"
import { getErrorMessageFrom } from "../../helpers/errorsHelper"
import { QuicklookPreviewType } from "../../types/geoMap"
import { ConfigurationsType } from "../../types/configurations"
import { errorToastNotification } from "../../helpers/toastNotificationHelper"
import {AppParametersType} from "../../types/app";

export const updateSuggestionsDispatchAction = (value) => async (dispatch) => {
  GeoCodingService.search(value).then(({ data }) => {
    const suggestions = data.features.map((item) => ({
      name: `${item.properties.label} ${
        item.properties.region ? `,${item.properties.region}` : ""
      }`,
      coordinates: item.geometry.coordinates.reverse(),
      score: item.properties.score,
    }))
    dispatch(setSuggestionsAction(suggestions))
  })
}

export const storeShapeCoordinatesDispatchAction =
  (shape: ShapeType) => async (dispatch) => {
    dispatch(storeLastShapeAction(shape))
  }
export const storeKMLGuideShapeCoordinatesDispatchAction =
  (shape: ShapeType) => async (dispatch) => {
    dispatch(storeKMLGuideShapeAction(shape))
  }

export const validateShapeWithNotification = (
  configurations: ConfigurationsType,
  appParameters: AppParametersType,
  scopeFields: string,
  formValues: any,
  newShape: ShapeType,
  language: string,
  bypassInscribedPolygon?: boolean,
  searchByProducts?: boolean,
  searchResults?: SearchResultsType
) => {
  return validateWithNotifications(
    validateShape(
      configurations,
      appParameters,
      scopeFields,
      formValues,
      newShape,
      language,
      bypassInscribedPolygon,
      searchByProducts,
      searchResults
    )
  )
}

export const selectNewAreaDispatchAction =
  (
    configurations: ConfigurationsType,
    appParameters: AppParametersType,
    scopeFields: string,
    formValues: any,
    newShape: ShapeType,
    language: string,
    searchByProducts?: boolean,
    searchResults?: SearchResultsType
  ) => (dispatch) => {
    return validateShapeWithNotification(
      configurations,
      appParameters,
      scopeFields,
      formValues,
      newShape,
      language,
      undefined,
      searchByProducts,
      searchResults
    ).then(() => {
      return dispatch(storeShapeCoordinatesDispatchAction(newShape))
    })
  }

export const selectKMLAreaDispatchAction =
  (
    configurations: ConfigurationsType,
    scopeFields: string,
    formValues: any,
    newShape: ShapeType,
    language: string
  ) => (dispatch) => {
    return new Promise((resolve) => {
      resolve(null)
    }).then(() => {
      return dispatch(storeKMLGuideShapeAction(newShape))
    })
  }

export const updatePathCoordinatesDispatchAction =
  (
    configurations: ConfigurationsType,
    appParameters: AppParametersType,
    selectedArea: ShapeType,
    formValues: any,
    pathString: string,
    language: string,
    searchByProducts?: boolean,
    searchResults?: SearchResultsType
  ) => (dispatch) => {
    const newShape = convertPathStringIntoShape(
      configurations,
      pathString,
      selectedArea,
      formValues,
      language,
    )
    return !!newShape
      ? dispatch(
        selectNewAreaDispatchAction(
          configurations,
          appParameters,
          "",
          formValues,
          newShape,
          language,
          searchByProducts,
          searchResults
        )
      )
    // old ondemand
    // dispatch(
    //     selectKMLAreaDispatchAction(
    //         configurations,
    //         "",
    //         formValues,
    //         newShape,
    //         language
    //     )
    // )
      : dispatch(removeLastShapeAction())
  }

export const getQuicklookPreviewDispatchAction =
  (
    configurations: ConfigurationsType,
    productImage: ProductImageStacType,
    isShownInMap: boolean = false,
    options: any = {}
  ) => (dispatch): Promise<QuicklookPreviewType> => {
    return ProductImageService.getQuicklookPreview(productImage)
      .then((response: any) => {
        return parseQuicklookPreviewFrom(
          configurations,
          productImage,
          response && response.data,
          isShownInMap
        )
      })
      .catch((errors) => {
        if (
          options.errorNotification &&
          errors &&
          errors.response &&
          !!errors.response.data
        ) {
          errors.response.data.text().then((c) => {
            const errorData = JSON.parse(c)
            errorToastNotification(
              getErrorMessageFrom({
                response: {
                  data: errorData,
                },
              })
            )
          })
        }
        return parseQuicklookPreviewFrom(configurations, productImage)
      })
      .then((newQuicklookPreview) => {
        dispatch(addQuicklookPreviewAction(newQuicklookPreview))
        return newQuicklookPreview
      })
  }
